/**
 * Creates the On Char Events / User Interactions tracking object
 */

import {TRACKING_WEBCHAT_TOOL} from '../constants';
import {TrackingData} from 'Container/Tracking/types';

/**
 * Create the page view tracking object
 * @param {object} trackingData - Tracking Data
 */
export const createTrackingChatInteraction = (trackingData: TrackingData) => {

     const trackingPayload = {
        action: trackingData.action,
        tool: TRACKING_WEBCHAT_TOOL,
        variant: trackingData.variant,
        provider: trackingData.provider,
    };

    return trackingPayload;
};
